import React from 'react'
import BotAvatar from './BotAvatar'

// A single chat bubble. role: 'user' | 'assistant' | 'error'.
// User text is rendered as-is; assistant/error render `children` (e.g. markdown).
export default function MessageBubble({ role, children }) {
  const isUser = role === 'user'
  const isError = role === 'error'
  return (
    <div style={{ display: 'flex', justifyContent: isUser ? 'flex-end' : 'flex-start', marginBottom: 8 }}>
      {!isUser && (
        <div style={{ padding: '2px 6px 0 0', flexShrink: 0 }}>
          <BotAvatar />
        </div>
      )}
      <div style={{
        maxWidth: '82%',
        background: isUser ? '#5B68C3' : (isError ? '#fdecea' : '#fff'),
        color: isUser ? '#fff' : (isError ? '#b3261e' : '#3C4654'),
        borderRadius: isUser ? '12px 12px 2px 12px' : '12px 12px 12px 2px',
        padding: '8px 12px', fontSize: 13, fontFamily: 'Inter, sans-serif', lineHeight: 1.6,
        boxShadow: isUser ? 'none' : '0px 1px 3px 0px rgba(0, 0, 0, 0.07)',
        border: isUser ? 'none' : (isError ? '1px solid #f5c6c2' : '1px solid #DFE1E4'),
        whiteSpace: isUser ? 'pre-wrap' : undefined,
      }}>
        {children}
      </div>
    </div>
  )
}
